document.addEventListener("DOMContentLoaded", function () {
	const mobileToggle = document.querySelector(".mobile-toggle");
	const navMenu = document.querySelector(".nav-menu");
	const dropdowns = document.querySelectorAll(".dropdown .dropbtn");

	dropdowns.forEach((btn) => {
		btn.addEventListener("click", function (e) {
			const dropdownContent = this.nextElementSibling;

			if (window.innerWidth <= 1200) {
				e.preventDefault();
				// Toggle the direct child dropdown only
				dropdownContent.classList.toggle("active");
			}
		});

		// Add hover functionality
		let timeout;
		const relatedDropdownContent = btn.nextElementSibling;

		// Function to position the dropdown
		const positionDropdown = (dropdownElement) => {
			const navMenu = document.querySelector(".nav-links");
			const justifyContent =
				getComputedStyle(navMenu).getPropertyValue("--nav-pos");
			if (justifyContent.trim() === "flex-end") {
				dropdownElement.style.left = "auto";
				dropdownElement.style.right = "100%";
			} else {
				dropdownElement.style.left = "100%";
				dropdownElement.style.right = "auto";
			}
		};

		btn.addEventListener("mouseenter", function (e) {
			if (window.innerWidth > 1200) {
				clearTimeout(timeout);
				relatedDropdownContent.classList.add("active");
				positionDropdown(relatedDropdownContent);

				// Remove 'active' from any deeper nested dropdowns (important!)
				const nestedDropdowns = relatedDropdownContent.querySelectorAll(
					".dropdown-content .dropdown-content"
				);
				nestedDropdowns.forEach((nestedDropdown) => {
					nestedDropdown.classList.remove("active");
				});
			}
		});

		btn.addEventListener("mouseleave", function (e) {
			// Listener on the BUTTON
			if (window.innerWidth > 1200) {
				timeout = setTimeout(() => {
					relatedDropdownContent.classList.remove("active");
				}, 300);
			}
		});

		relatedDropdownContent.addEventListener("mouseenter", function (e) {
			if (window.innerWidth > 1200) {
				clearTimeout(timeout);
				positionDropdown(this);

				// Only add active to DIRECT children of the hovered dropdown
				const directChildDropdowns = this.querySelectorAll(
					":scope > .dropdown-content"
				);
				const directChildDropdownsArray = [...directChildDropdowns];

				directChildDropdownsArray.forEach((childDropdown) => {
					childDropdown.classList.add("active");
					positionDropdown(childDropdown);
				});

				// Remove active from ANY deeper nested dropdowns (important!)
				const nestedDropdowns = this.querySelectorAll(
					".dropdown-content .dropdown-content"
				);
				nestedDropdowns.forEach((nestedDropdown) => {
					if (!directChildDropdownsArray.includes(nestedDropdown)) {
						nestedDropdown.classList.remove("active");
					}
				});
			}
		});

		relatedDropdownContent.addEventListener("mouseleave", function (e) {
			if (window.innerWidth > 1200) {
				timeout = setTimeout(() => {
					// Set a timeout
					this.classList.remove("active");
					const childDropdowns =
						relatedDropdownContent.querySelectorAll(
							".dropdown-content"
						);
					childDropdowns.forEach((childDropdown) => {
						childDropdown.classList.remove("active");
					});
				}, 300); // Adjust delay as needed (e.g., 300ms)
			}
		});
	});

	// Close dropdowns when clicking outside (modified to only close direct children)
	window.onclick = function (event) {
		if (!event.target.matches(".dropbtn")) {
			const dropdownContents =
				document.querySelectorAll(".dropdown-content");
			dropdownContents.forEach((dropdownContent) => {
				dropdownContent.classList.remove("active");
			});
		}
	};

	mobileToggle.addEventListener("click", () => {
		navMenu.classList.toggle("active");
		mobileToggle.setAttribute(
			"aria-expanded",
			navMenu.classList.contains("active")
		);
	});
});
